export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9267.08905fde.jpg";